import { Link } from "react-router-dom";
import NewsletterForm from "@/components/feature/NewsletterForm";
import { brand } from "@/mocks/site";

export default function CtaBand() {
  return (
    <section className="bg-primary-700 text-background-50">
      <div className="max-w-shell mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-6">
            <p className="text-xs font-medium tracking-[0.2em] text-primary-200 uppercase">
              投稿与订阅
            </p>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold leading-snug">
              手里有可核实的线索？投过来，我们帮你把证据捋一遍
            </h2>
            <p className="mt-4 text-sm md:text-base text-primary-100 leading-relaxed max-w-xl">
              请尽量附上原始材料与时间信息。涉及个人隐私、未成年与医疗信息的内容，我们不会进入鉴定流程。
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <Link
                to="/contact"
                className="px-6 py-3 rounded-control bg-background-50 text-primary-700 text-sm font-medium hover:bg-background-100 transition-colors text-center whitespace-nowrap"
              >
                提交投稿
              </Link>
              <Link
                to="/gossip"
                className="px-6 py-3 rounded-control border border-primary-300 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors text-center whitespace-nowrap"
              >
                先看看爆料库
              </Link>
            </div>
          </div>

          <div className="lg:col-span-6 w-full">
            <div className="rounded-card bg-background-50 p-5 md:p-6">
              <h3 className="font-heading text-base font-bold text-foreground-950">
                每周鉴定播报
              </h3>
              <p className="mt-2 mb-4 text-sm text-foreground-600 leading-relaxed">
                一周一封，只写新增的实锤、反转与辟谣汇总，随时可退订。
              </p>
              <NewsletterForm variant="block" />
              <p className="mt-4 pt-4 border-t border-background-200 text-xs text-foreground-500">
                也可以直接写邮件到 {brand.tipEmail}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}